/**
 * Role mock data — 8 system roles (isSystem=true, locked) + 2 custom examples.
 * TODO: EXTENSION BEYOND SITEMAP v1.1 (requested by user, modeled after inventory legacy UI).
 * System role alias dùng chung enum với StaffRole cũ để tương thích.
 */

export interface TenantRole {
  _id: string;
  name: string;
  alias: string;
  description?: string;
  permissionKeys: string[];
  isSystem: boolean;
  createdAt: string;
  updatedAt: string;
}

const now = new Date().toISOString();

export const SYSTEM_ROLE_IDS = {
  owner: 'role-sys-owner',
  manager: 'role-sys-manager',
  inventory: 'role-sys-inventory',
  viewer: 'role-sys-viewer',
  b2b_sales: 'role-sys-b2b-sales',
  b2b_sales_manager: 'role-sys-b2b-sales-manager',
  accountant: 'role-sys-accountant',
} as const;

export const mockRoles: TenantRole[] = [
  {
    _id: SYSTEM_ROLE_IDS.owner,
    name: 'Chủ chi nhánh',
    alias: 'owner',
    description: 'Quyền cao nhất — full access, billing, tenant settings.',
    permissionKeys: ['*'],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: SYSTEM_ROLE_IDS.manager,
    name: 'Quản lý',
    alias: 'manager',
    description: 'Quản lý chi nhánh — users, inventory, reports.',
    permissionKeys: [
      'pos.use',
      'pos.refund',
      'pos.buy_in',
      'pos.shifts_manage',
      'products.view',
      'products.create',
      'products.update',
      'products.delete',
      'products.print_label',
      'services.view',
      'services.create',
      'services.update',
      'services.delete',
      'orders.view',
      'orders.cancel',
      'orders.print',
      'inventory.stock.view',
      'inventory.receipts.manage',
      'inventory.issues.manage',
      'inventory.counts.manage',
      'inventory.transfers.manage',
      'reports.revenue',
      'reports.inventory',
      'staff.view',
      'staff.manage',
      'customers.view',
      'customers.manage',
      'settings.business',
      'settings.hardware',
      'settings.theme',
      'settings.profile',
      'settings.security',
      'settings.notifications',
      'settings.locale',
    ],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: SYSTEM_ROLE_IDS.inventory,
    name: 'Thủ kho',
    alias: 'inventory',
    description: 'Quản lý tồn kho, nhập/xuất/kiểm kê/chuyển kho.',
    permissionKeys: [
      'products.view',
      'services.view',
      'inventory.stock.view',
      'inventory.receipts.manage',
      'inventory.issues.manage',
      'inventory.counts.manage',
      'inventory.transfers.manage',
      'miniapp.warehouse.access',
      'settings.profile',
      'settings.security',
    ],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: SYSTEM_ROLE_IDS.viewer,
    name: 'Người xem',
    alias: 'viewer',
    description: 'Chỉ xem báo cáo doanh thu / tồn kho.',
    permissionKeys: [
      'reports.revenue',
      'reports.inventory',
      'services.view',
      'customers.view',
      'settings.profile',
      'settings.security',
    ],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: SYSTEM_ROLE_IDS.b2b_sales,
    name: 'Nhân viên kinh doanh B2B',
    alias: 'b2b_sales',
    description: 'Quản lý khách hàng, đơn hàng và CRM B2B trong phạm vi được giao.',
    permissionKeys: [
      'b2b.access', 'b2b.customers.view', 'b2b.customers.create', 'b2b.customers.manage',
      'b2b.pricing.view', 'b2b.rebates.view', 'b2b.crm.manage',
      'combos.view',
    ],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: SYSTEM_ROLE_IDS.b2b_sales_manager,
    name: 'Quản lý kinh doanh B2B',
    alias: 'b2b_sales_manager',
    description: 'Quản lý đội kinh doanh, chính sách giá và vận hành B2B.',
    permissionKeys: [
      'b2b.access', 'b2b.customers.view', 'b2b.customers.create', 'b2b.customers.manage', 'b2b.customers.transfer',
      'b2b.pricing.view', 'b2b.pricing.manage', 'b2b.rebates.view', 'b2b.rebates.manage',
      'b2b.rebates.approve', 'b2b.receivables.view', 'b2b.crm.manage',
      'combos.view', 'combos.manage',
      'b2b.reports.view',
    ],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: SYSTEM_ROLE_IDS.accountant,
    name: 'Kế toán',
    alias: 'accountant',
    description: 'Đối soát công nợ, chiết khấu và hóa đơn B2B.',
    permissionKeys: [
      'b2b.access', 'b2b.customers.view',
 'b2b.pricing.view', 'b2b.rebates.view', 'b2b.rebates.approve',
      'b2b.receivables.view', 'b2b.receivables.manage',
      'b2b.reports.view',
    ],
    isSystem: true,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: 'role-custom-shift-lead',
    name: 'Trưởng ca',
    alias: 'shift_lead',
    description: 'Thu ngân cấp cao — bán + duyệt đổi trả + xem báo cáo doanh thu.',
    permissionKeys: [
      'pos.use',
      'pos.refund',
      'products.view',
      'services.view',
      'orders.view',
      'orders.cancel',
      'orders.print',
      'reports.revenue',
    ],
    isSystem: false,
    createdAt: now,
    updatedAt: now,
  },
  {
    _id: 'role-custom-warehouse-supervisor',
    name: 'Giám sát kho',
    alias: 'warehouse_supervisor',
    description: 'Thủ kho cấp cao — có báo cáo tồn kho + quản lý nhân viên kho.',
    permissionKeys: [
      'products.view',
      'services.view',
      'inventory.stock.view',
      'inventory.receipts.manage',
      'inventory.issues.manage',
      'inventory.counts.manage',
      'inventory.transfers.manage',
      'reports.inventory',
      'staff.view',
    ],
    isSystem: false,
    createdAt: now,
    updatedAt: now,
  },
];

export function slugifyAlias(input: string): string {
  return input
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/đ/g, 'd')
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');
}
